import Podcast from "./Podcast";
import { PodcastData } from "../const/data";
import PageMeta from "./PageMeta";

const PodcastContainer = () => {
  return (
    <div>
      <PageMeta
        title="Podcasts"
        description="Podcasts on tech, programming, history, and geek culture that I listen to every week — my personal picks."
        path="/podcasts"
      />
      <div className="podIntro">
        <h2 className="or">Podcasts I listen to</h2>
        <p>
          Some time ago I started listening to a lot of podcasts. Some concern
          technology and programming, some concern history or civilizational
          issues and, of course, some are really geeky. I chose to present you
          some I just have to listen once a new episode is out. Enjoy!
        </p>
      </div>
      <div className="podContainer">
        {PodcastData.map((item) => (
          <Podcast
            title={item.title}
            description={item.description}
            key={item.title}
            language={item.language}
            url={item.url}
            imageUrl={item.imageUrl}
          />
        ))}
      </div>
    </div>
  );
};

export default PodcastContainer;
